import { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router";
import { message } from "antd";

const useRequest = (endpoint, method = "GET", body = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const isTokenExpired = (token) => {
    if (!token) return true;
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  };

  const refreshAccessToken = async () => {
    const baseUrl = process.env.REACT_APP_API_URL;
    if (!baseUrl) {
      throw new Error("REACT_APP_BASE_URL is not defined");
    }

    try {
      const response = await axios.post(`${baseUrl}users/refresh/`, {
        refresh: localStorage.getItem("refreshToken"),
      });
      localStorage.setItem("accessToken", response.data.access);
      return response.data.access;
    } catch (err) {
      localStorage.clear();
      navigate("/login");
    }
  };

  const noAuthEndpoints = ["login"]; // Add your no-auth endpoints here

  const request = async (
    method = "GET",
    endpoint,
    successHandler,
    errorHandler,
    body = null,
    params = {}
  ) => {
    try {
      setLoading(true);
      let headers = {
        "Content-Type": "application/json",
      };

      if (!endpoint.includes(noAuthEndpoints)) {
        let accessToken = localStorage.getItem("accessToken");

        if (!localStorage.getItem("refreshToken")) {
          localStorage.clear();
          message.error("Debes volver a iniciar sesión");
          navigate("/login");
          return;
        }

        if (isTokenExpired(accessToken)) {
          accessToken = await refreshAccessToken();
        }

        headers.Authorization = `Bearer ${accessToken}`;
      }

      const baseUrl = process.env.REACT_APP_API_URL;
      if (!baseUrl) {
        throw new Error("REACT_APP_BASE_URL is not defined");
      }

      const response = await axios({
        url: `${baseUrl}${endpoint}`,
        method,
        data: body,
        headers,
        params,
      });

      successHandler(response.data);
      return response.data; // Return the response data
    } catch (error) {
      errorHandler(error.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (endpoint && method && body) request(endpoint, method, body);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, method, body]);

  return { data, loading, error, request };
};

export default useRequest;
